import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/base/basePortType/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/base/basePortType',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/base/basePortType',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/base/basePortType/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/base/basePortType',
    method: 'get',
    params: {
      id
    }
  })
}
export function listOption(params) {
  return request({
    url: '/api/base/basePortType/listOption',
    method: 'get',
    params
  })
}
